import { Injectable } from '@angular/core';
import { FeathersService } from './feathers.service';
import { defer, forkJoin, Observable } from 'rxjs';
import { ApiEndpoint } from '../../enums';
import { LingFileEntity } from '../../models/ling-file-entity';

@Injectable({
  providedIn: 'root',
})
export class FilesService {
  constructor(private feathers: FeathersService) {}

  get(id: string): Observable<LingFileEntity> {
    return this.feathers.pipedFrom(
      defer<LingFileEntity[]>(() =>
        this.feathers.feathersREST.service(ApiEndpoint.Media).get(id)
      )
    );
  }

  uploadMedia(files: File | File[]): Observable<LingFileEntity[]> {
    const formData = new FormData();
    if (Array.isArray(files)) {
      files.forEach((file: File) => {
        formData.append('files', file);
      });
    } else {
      formData.append('files', files);
    }
    return this.feathers.pipedFrom<LingFileEntity[]>(
      defer<LingFileEntity[][]>(() =>
        this.feathers.feathersREST.service(ApiEndpoint.Media).create(formData)
      )
    );
  }

  deleteMedia(ids: string[]): Observable<LingFileEntity[]> {
    const deletionCalls = ids.map((id) =>
      this.feathers.pipedFrom<LingFileEntity>(
        defer<LingFileEntity[]>(() =>
          this.feathers.feathersREST.service(ApiEndpoint.Media).remove(id)
        )
      )
    );
    return forkJoin(deletionCalls);
  }
}
